import { twMerge } from 'tailwind-merge'
import definePrimitive from '../../util/definePrimitive'

export const BaseTableDisplay = definePrimitive({
  element: 'table',
  name: 'BaseTableDisplay',
  className: twMerge('core-table-display', 'border-b border-gray-200')
})

export const BaseTableBody = definePrimitive({
  element: 'tbody',
  name: 'BaseTableBody',
  className: twMerge('core-table-body', 'contents')
})

export const BaseTableHeader = definePrimitive({
  element: 'thead',
  name: 'BaseTableHeader',
  className: twMerge('core-table-header', 'contents')
})

export const BaseTableHeaderCell = definePrimitive({
  element: 'th',
  name: 'BaseTableHeaderCell',
  className: twMerge('core-table-header-cell', 'typo-subheading flex items-center border-b border-gray-200 px-2 pb-1 text-left uppercase text-gray-600')
})

export const BaseTableDataCell = definePrimitive({
  element: 'td',
  name: 'BaseTableDataCell',
  className: twMerge('core-table-data-cell', 'typo-body flex min-h-[3rem] items-center border-t border-gray-200 px-2 text-left [.core-highlighted>&]:bg-gray-100')
})

export const BaseTableRow = definePrimitive({
  element: 'tr',
  name: 'BaseTableRow',
  className: twMerge('core-table-row', 'contents [&:hover>.core-table-data-cell]:bg-gray-50')
})

export const BaseSearch = definePrimitive({
  element: 'div',
  name: 'BaseSearch',
  className: twMerge('core-table-search', 'flex min-h-[5rem] items-center [grid-area:search] [&+.core-table-filters]:ml-4')
})

export const BaseExtras = definePrimitive({
  element: 'div',
  name: 'BaseExtras',
  className: twMerge('core-table-extras', 'flex min-h-[5rem] items-center [grid-area:extras]')
})

export const BasePagination = definePrimitive({
  element: 'div',
  name: 'BasePagination',
  className: twMerge('core-table-pagination', 'flex min-h-[5rem] items-center [grid-area:pagination]')
})

export const BaseFilters = definePrimitive({
  element: 'div',
  name: 'BaseFilters',
  className: twMerge('core-table-filters', 'flex min-h-[5rem] min-w-[15rem] items-center gap-4 [grid-area:filters]')
})

export const BaseEmptyView = definePrimitive({
  element: 'div',
  name: 'BaseEmptyView',
  className: twMerge('core-table-empty-view', 'flex items-center justify-center pt-40 [grid-area:display]')
})

export const BaseRowDetails = definePrimitive({
  element: 'div',
  name: 'BaseRowDetails',
  className: twMerge('core-row-details', 'col-start-1 col-end-[-1] pb-4 text-gray-600')
})
